export enum PaymentSchemesOrdering {
  Name,
  CreatedAt,
}
